var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 58,
    viewBox: "0 0 62 58",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-3h64v64H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 52.22c.69.512 2.91 1.85 4.8 1.85 1 0 2.091-.379 3-.807v4.227c-.932.298-1.95.51-3 .51-2.397 0-4.663-1.076-6-1.863-1.337.787-3.603 1.863-6 1.863s-4.663-1.076-6-1.863C28.663 56.924 26.396 58 24 58a9.194 9.194 0 0 1-2-.238v-4.088c.655.23 1.346.396 2 .396 1.904 0 4.16-1.37 4.8-1.85l1.2-.9 1.2.9c.69.512 2.91 1.85 4.8 1.85 1.904 0 4.16-1.37 4.8-1.85l1.2-.9 1.2.9zM53 41h9v17h-9V41zm-4.23-10.735L20 46.875V58H4V41h10V25.075l3.894-3.909c.327-.387.061-.655.013-.69l-.02.002L3.301 29.84a1 1 0 0 1-1.505-.571l-1.76-6.306a1 1 0 0 1 .504-1.156L42.128.22a1.967 1.967 0 0 1 1.973 3.398L41 5.612v22.211l4.77-2.754 3 5.196zM38 7.54L20 19.108v20.84l18-10.393V7.54z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.b7085751372801469e58234e86f0f895.svg";
export { ForwardRef as ReactComponent };